import React, { useEffect } from 'react';
import { CommonPageStep, ForgetPasswordPageStep } from '..';
import { Button, Grid, TextField } from '@mui/material';
import _, { debounce } from 'lodash';
import { bool } from 'prop-types';
import * as qs from 'query-string';
import { isMobileOnly } from 'react-device-detect';
import apiHelper, {
  SupportedIncomingFormat,
  SupportedMethod,
  SupportedOutgoingFormat,
  SupportedServers,
} from '../../common/ApiHelper';
import { verifyDataFormat } from '../../common/CommonTools';
import { appConfig } from '../../common/ConfigLoader';
import { useAppSelector } from '../../store/hooks';
import { setAppPageStep } from '../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../store/store';

export interface ForgetPasswordElementInterface {
  emailInputTextfield: JSX.Element;
  submitButton: JSX.Element;
  forgetEmailButton: JSX.Element;
  sentEmailIcon: JSX.Element;
}

export const ForgetPasswordElement = (): ForgetPasswordElementInterface => {
  // REDUX

  // HOOKS
  const [emailInputError, setEmailInputError] = React.useState(false);
  const [emailInput, setEmailInput] = React.useState('');
  const [defaultEmailInput, setDefaultEmailInput] = React.useState<string>();

  useEffect(() => {
    const email = qs.parse(window.location.search).email as string;
    if (email) setEmailInput(email);
  }, []);

  // ELEMENT
  const onEmailInputChange = debounce(
    async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
      setEmailInput(event.target.value);

      console.log(event.target.value);
      // CHECK EMAIl FORMAT
      const verifyResult = verifyDataFormat(event.target.value, {
        type: 'EMAIL',
      });

      if (!verifyResult) {
        setEmailInputError(true);
        return;
      }

      // CHECK IF USERNAME EXISTED OR NOT
      const usernameVerifyEndpoint = 'user/UsernameVerify';
      const usernameVerifyData = {
        username: event.target.value,
      };
      const usernameVerifyResult = await apiHelper(
        SupportedServers.ACCOUNT,
        usernameVerifyEndpoint,
        SupportedMethod.POST,
        usernameVerifyData,
        {
          incomingFormat: SupportedIncomingFormat.JSON,
          outgoingFormat: SupportedOutgoingFormat.JSON,
        },
      );

      if (usernameVerifyResult.success) {
        if (usernameVerifyResult.data) {
          setEmailInputError(false);
        } else {
          // CANNOT FOUND USER
          setEmailInputError(true);
        }
      }
    },
    500,
  );

  const emailInputTextfield: JSX.Element = (
    <React.Fragment>
      <TextField
        type="email"
        variant="outlined"
        size="medium"
        margin="none"
        label="Enter Email"
        error={emailInputError}
        helperText={
          emailInputError
            ? `❗The email address you've entered doesn't match any account. Please try again.`
            : ''
        }
        onChange={onEmailInputChange}
        fullWidth={true}
        sx={isMobileOnly ? { width: 'stretch' } : { width: '100%' }}
        onInput={(event): void => {
          const textField = event.target as HTMLInputElement;
          setEmailInput(textField.value.toLowerCase());
        }}
        value={emailInput}
      />
    </React.Fragment>
  );

  const submitButton = (
    <React.Fragment>
      <Button
        variant="contained"
        color="primary"
        style={{ marginTop: '32px' }}
        disabled={emailInputError || emailInput === ''}
        onClick={async () => {
          if (emailInputError || emailInput === '') {
            console.warn('INVALID EMAIL INPUT');
            return;
          }

          const resetPasswordEmailEndpoint = 'user/UserForgetPassword';
          const resetPasswordEmailData = { username: emailInput };
          const resetPasswordEmailResult = await apiHelper(
            SupportedServers.ACCOUNT,
            resetPasswordEmailEndpoint,
            SupportedMethod.POST,
            resetPasswordEmailData,
            {
              outgoingFormat: SupportedOutgoingFormat.JSON,
              incomingFormat: SupportedIncomingFormat.JSON,
            },
          );

          if (resetPasswordEmailResult.success) {
            outsideComponentDispatch(
              setAppPageStep(ForgetPasswordPageStep.SENT),
            );
          }
        }}
      >
        Submit
      </Button>
    </React.Fragment>
  );

  const forgetEmailButton = (
    <React.Fragment>
      <Button
        variant="text"
        color="primary"
        sx={{
          boxShadow: 'none',
        }}
        onClick={() => {
          outsideComponentDispatch(setAppPageStep(CommonPageStep.FORGETEMAIl));
        }}
      >
        forgot email?
      </Button>
    </React.Fragment>
  );

  const sentEmailIcon = (
    <React.Fragment>
      <img
        id="login-main-back-button"
        alt=""
        src="assets/common/email-sent-icon.png"
        style={{ marginTop: '28px' }}
        onClick={() => {}}
      />
    </React.Fragment>
  );

  return {
    emailInputTextfield,
    submitButton,
    forgetEmailButton,
    sentEmailIcon,
  };
};
